<template>
    <div>
        <Navbar />
        <br>
        <div class="firstSectionContainer">
    <img class="polygon" :src="Polygon" alt="Polygon1" />
    <div class="titleContainer">
      <div class="imageContainer">
        <img class="img" :src="img" alt="img" />
        <button class="signInBtn ">
          <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
          <span>Demande d’inscription</span>
        </button>
      </div>

    </div><br><br>
    <div class="textContainer">
      <p class="bold">
        PREXANGE : retour du client centrique ! 
      </p><br>
      <p> PREXANGE permet aux demandeurs de crédit, accompagnés de leur courtier, d’optimiser leurs chances de trouver le meilleur financement, dans un délai très court !<br><br>
       Accès à un espace privé sécurisé et à un coffre fort digital pour transférer les documents personnels.</p>
    </div>
    
    <div class="btnContainerWithactions">
      <button class="actionButton">
        <Icon class="icon" icon="fluent:arrow-right-24-regular" height="24" />
        Comment ça marche ?
      </button>
      <a  href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank" class="actionButtonSecandary">
        <span class="text1">
          Démarrer une collaboration
        </span>
        <span class="text2">
          Contact
        </span>
      </a>
    </div>
  </div>
  <div class="sectionTwoContainer">
    <h1 class="title">
      Les possibilités qu’offre PREXANGE

    </h1>
    <div class="bloksContainer">
      <div class="block">
        <div class="iconContainer">
          <Icon icon="octicon:devices-16" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Multi-device </span>
          <p class="text">
            Prexange met à votre disposition différents outils afin de vous permettre d’être à la pointe de la technologie, que vous soyez sur mobile ou sur votre ordinateur de bureau.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="subway:time" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Avantages Concurrentiels de PREXANGE</span>
          <p class="text">
             PREXANGE permet à tout courtier IOBSP d’accéder à une offre élargie de partenaires bancaires régionaux et nationaux, sans qu’il soit nécessaire d’avoir une convention en direct, …
          </p>
          <p class="text"> Principe d’appel d’offre en multi présentation simultanée : mettez à profit le temps gagné pour développer votre activité.  </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="material-symbols:euro" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Et Plus encore !</span>
          <p class="text">Marque Blanche </p>
            <p class="text">
               Co-Branding prescripteurs: permettez à vos partenaires prescripteurs de créer ”leurs propres services de financement” et de vous mettre en avant auprès de leurs clients .</p>
            <p class="text"> tarification au succès : absence d’abonnement et d’engagement de durée .</p>  
          </div>
      </div>
    </div>
    <div>
      <div class="slider">
        <VueSlickCarousel v-bind="settings">
          <div class="block">
        <div class="iconContainer">
          <Icon icon="octicon:devices-16" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Multi-device </span>
          <p class="text">
            Prexange met à votre disposition un catalogue de demandes de financements,  que vous soyez sur mobile ou sur votre ordinateur de bureau.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="hugeicons:folder-search" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Recherche</span>
          <p class="text">
            Renseignez vos critères de recherches, trouvez les dossiers les plus attractifs et ajoutez-les à vos favoris.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="material-symbols:euro" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Propositions</span>
          <p class="text">
            La synthèse financière du dossier vous convient, faîtes une proposition simplement et rapidement.</p>
        </div>
      </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>

  <div class="ThirdSectionContainer">
    <!-- 2 div left and right -->
    <div class="leftBox">
      <div class="imageContainer">
         <img class="leftBoxImage" :src="image" alt="image">
         <button class="signInBtn ">
        <Icon class="iconbtn" icon="fluent:arrow-right-24-regular" height="20" />
        Demander une démonstration
      </button>
      <Icon class="icon" icon="bi:play-btn" height="80" />
      </div>
    </div>
    <div class="rightBox">
      <div class="firstsection">
        <h1 class="title">
            Un suivi en temps réel de l'avancée de vos dossiers
        </h1>
      </div>
      <div class="secondsection">
        <div class="card">
          <div>
           <img :src="icon18" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Suivi
            </span>
            <P class="detailcard">
                L'application Prexange vous permet de suivre en temps réel l'avancée de vos dossiers.
            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon19" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Proposition
            </span>
            <P class="detailcard">
              Déposez vos dossiers clients et recevez les propositions des partenaires bancaires.            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon20" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Pilotage
            </span>
            <P class="detailcard">
              Pilotez votre production en quelques clics seulement.            </P>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="FourthSectionContainer">
        <div class="leftBox">
            <img class="leftBoxImage" :src="imageService" alt="image">
        </div>
        <div class="rightBox">
            <h1 class="title">
              Diversifiez vos activités
            </h1>
            <div class="detail">
                <p>
                  Liberté d’exercer ses activités et d’en développer d’autres (gestion de patrimoine, courtage en assurance, transactions immobilières, etc) sans aucun mécanisme ressemblant de près ou de loin à une clause de non-concurrence.            
                </p>
            </div>
            <button class="signInBtn">
                <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
                <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="color: white; text-decoration: none;"><span>Demande d’inscription </span></a>
            </button>
        </div>
    </div>
 
        <Footer id="footer"></Footer>
    </div>
</template>

<script>

import Navbar from './navbar/navbar.vue';
import Footer  from '@/components/footer.vue';
import Polygon from '@/assets/images/prexange_services_2.png';
import img from '@/assets/images/services.png';
import image from '@/assets/images/bg3sec.png';
import imageService from '@/assets/images/prexange_services_5.jpg';
import imageCatalogue from '@/assets/images/prexange3.jpg';
import image2 from '@/assets/images/se3box2.png';
import icon18 from '@/assets/images/suivi.png';
import icon19 from '@/assets/images/proposition.png';
import icon20 from '@/assets/images/pilotage.png';
import { Icon } from '@iconify/vue2';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueSlickCarousel from 'vue-slick-carousel'


export default {
    name: 'Home',
    components: {
        Navbar,
        Footer,
        Icon,
        VueSlickCarousel
    },
    
  data() {
    return {
      Polygon: Polygon,
      img: img,
      isSidebarOpen: false,
      image: image,
      image2: image2,
      icon18: icon18,
      icon19: icon19,
      icon20: icon20,
      imageService: imageService,
      imageCatalogue: imageCatalogue
    };
  },
};
</script>

<style scoped>
.img {
 
  margin-left: 220px; /* Space between the image and text */
}

.sectionTwoContainer {
  background-image: url("../../../assets/images/prexange3.jpg");
}
</style>

<style lang="scss">
@import './firstScetion/firstSection.scss';
@import './ThirdSection/ThirdSection.scss';
@import './FourthSection/FourthSection.scss';
@import './SixthSection/SixthSection.scss';
@import './NosServices/nosservices.scss';
</style>
